import React from 'react'
import Navbar from './Navbar'
import AboutSection from './AboutSection'
import FounderIntro from './FounderIntro'
import Footer from './Footer'

export default function About() {
  return (
    <>
      <Navbar/>
      <AboutSection/>
      <FounderIntro/>
      <Footer/>
    </>
  )
}
